export const colorMaterial = (color) => String(color.materialType || color.material || "Nincs anyag").trim();
export const colorGroups = (color) => [...new Set(String(color.groupName || "").split("|").map(s=>s.trim()).filter(Boolean))];
export function materialGroups(colors, material) {
  return [...new Set(colors.filter(c=>colorMaterial(c)===material).flatMap(colorGroups))].sort((a,b)=>a.localeCompare(b));
}
export function filterPaletteColors(colors, material, group, search, translate = (s)=>s) {
  const query=search.trim().toLocaleLowerCase();
  return colors.filter(c=>colorMaterial(c)===material && (!group || colorGroups(c).includes(group)) &&
    (!query || String(translate(c.name) || c.name || "").toLocaleLowerCase().includes(query)));
}
